<template>
  <div id="liveDetailView" class="market-view-container">

    <div v-if="tooltip.visible" class="tracker-custom-tooltip" :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }">
      {{ tooltip.text }}
    </div>

    <div class="loader-wrapper" v-if="getLoadingDetail">
      <v-progress-linear indeterminate color="var(--color-primary)" height="3" background-opacity="0" class="z-index-max"></v-progress-linear>
    </div>

    <transition-group name="fade-fast" mode="out-in">

      <div class="event-wrapper" v-for="(object, index) in getEventsLiveDetail" :key="object.event.id || index">

        <div class="match-hero" :style="styleMatchHero(object.event.sportId)">

          <smart-toolbar-american
              ref="smartToolbar"
              :groups="filteredGroups"
              :group-selected="groupSelected"
              :tabs-scrollable="false"
              :is-small-screen="isSmallScreen"
              :search-query="searchQuery"
              :show-expand-collapse="true"
              :show-change-col="true"
              :small-label="true"
              :show-search="false"
              :expansion-opened="expansionAllOpen"
              :col-to-show="colToShow"
              @update:searchQuery="onSearchQueryUpdate"
              @update:groupSelected="onSelectGroup"
              @toggleExpansion="toggleAll"
              @changeCol="changeCol"
              @exitSearchMode="exitSearchMode(object)"
          />

        </div>

        <div class="market-search-dropdown" v-if="showMarketSearchDropdown && filteredAvailableMarkets.length > 0">
          <div
              v-for="market in filteredAvailableMarkets"
              :key="market.marketId"
              class="market-search-item"
              @mousedown.prevent="selectMarketFromSearch(market, object)"
          >
            {{ market.marketAlias || market.marketName }}
          </div>
        </div>

        <div class="markets-wrapper" :class="{ 'markets-wrapper--finished': object.matchFinished, 'odds-loading': liveBetBuilderCartLocked }">

          <div v-if="groupSelected === 'favourites' && !tab_loading && pinnedMarkets.length === 0" class="favourites-empty">
            <v-icon color="#777" size="36">mdi-star-outline</v-icon>
            <p>{{ $t('noFavouriteMarkets') || 'No favourite markets' }}</p>
            <p class="favourites-empty__hint">{{ $t('noFavouriteMarketsHint') || 'Pin ☆ a market to add it here' }}</p>
          </div>

          <div v-else-if="tab_loading" class="skeleton-loader">
            <div class="skel-split-layout">
              <div class="skel-column">
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-45"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-3"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-55"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-2"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-35"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-3"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-50"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-2"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
              </div>
              <div class="skel-column">
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-50"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-2"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-40"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-3"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-60"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-2"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
                <div class="skel-panel mb-2">
                  <div class="skel-panel-header"><div class="skel-item skel-label w-45"></div></div>
                  <div class="skel-panel-body"><div class="skel-odds-grid cols-3"><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div><div class="skel-item skel-odd"></div></div></div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="object.event.odds && object.event.odds.length > 0">

            <div class="markets-split-layout">

              <div class="markets-column" v-for="colIndex in colToShow" :key="colIndex">
                <template v-for="(marketLines, index) in processedMarketsForDetail">

                  <v-expansion-panels
                      v-if="colToShow.length === 1 || index % 2 === colIndex"
                      :key="marketLines[0].unique_id"
                      v-model="panelsState[marketLines[0].unique_id]"
                      flat class="custom-panels mb-2"
                  >
                    <v-expansion-panel class="market-panel">

                      <v-expansion-panel-header class="panel-header">
                        <div class="header-content">
                          <div class="market-title-area">


                            <span class="market-name">{{ marketLines[0].marketAlias || marketLines[0].marketName }}</span>

<!--                            <v-icon-->
<!--                                small class="ml-2 info-market-icon"-->
<!--                                @click.stop="openMarketInfo(marketLines[0], object)"-->
<!--                                @mouseenter="!isMobileOnly && showTooltip($event, $t('infoMarket') || 'Info Market')"-->
<!--                                @mousemove="!isMobileOnly && updateTooltipPos($event)"-->
<!--                                @mouseleave="!isMobileOnly && hideTooltip()"-->
<!--                            >mdi-information-outline</v-icon>-->

                            <span v-if="marketLines.length === 1 && hasValidSpecifier(marketLines[0])" class="specifier-tag ml-2">
                                                            {{ stripScoreState(marketLines[0].specifier) }}
                                                        </span>
                          </div>

                          <div class="header-actions" v-if="isCorrectScoreMarket(marketLines[0])">
                            <div class="main-all-pill">
                              <button :class="{ active: isCompact(marketLines[0]) }" @click.stop="!isCompact(marketLines[0]) && toggleCompactMode(marketLines[0], object.event)">Main</button>
                              <button :class="{ active: !isCompact(marketLines[0]) }" @click.stop="isCompact(marketLines[0]) && toggleCompactMode(marketLines[0], object.event)">All</button>
                            </div>
                          </div>
                        </div>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content class="panel-body">
                        <div class="grid-container">

                          <div v-if="isPlayerMarket(marketLines[0])" class="player-market-wrapper">
                            <div class="player-team-toolbar" v-if="_detailBothSidesHaveData(marketLines, object.event)">
                              <div class="player-team-track">
                                <button class="player-team-btn" :class="{ 'active': getSelectedPlayerTeam(marketLines[0].unique_id) === 'home' }" @click="setSelectedPlayerTeam(marketLines[0].unique_id, 'home')">
                                  <LogoCompetitors :team-id="object.event.home_id" height="20px" width="20px" style="height: 20px; width: 20px" />
                                  {{ object.event.home }}
                                </button>
                                <button class="player-team-btn" :class="{ 'active': getSelectedPlayerTeam(marketLines[0].unique_id) === 'away' }" @click="setSelectedPlayerTeam(marketLines[0].unique_id, 'away')">
                                  <LogoCompetitors :team-id="object.event.away_id" height="20px" width="20px" style="height: 20px; width: 20px" />
                                  {{ object.event.away }}
                                </button>
                                <div class="player-team-indicator" :style="getSelectedPlayerTeam(marketLines[0].unique_id) === 'home' ? 'left:0;width:50%' : 'left:50%;width:50%'"></div>
                              </div>
                            </div>

                            <div v-if="isSpecifierPlayerMarket(marketLines)" class="player-specifier-row">
                              <template v-for="_playerSide in [getSelectedPlayerTeam(marketLines[0].unique_id)]">
                                <v-menu v-model="playerSpecifierMenuOpen[_detailPlayerKey(marketLines, _playerSide)]" offset-y bottom content-class="player-specifier-menu" dark :close-on-content-click="false">
                                  <template v-slot:activator="{ on, attrs }">
                                    <div class="player-spec-btn" v-bind="attrs" v-on="on">
                                      <v-icon x-small class="mr-1">mdi-account-outline</v-icon>
                                      <span class="text-truncate">{{ getSelectedPlayerLabelDetail(marketLines, object.event, _playerSide) }}</span>
                                      <v-icon x-small class="ml-1">mdi-chevron-down</v-icon>
                                    </div>
                                  </template>
                                  <div class="player-spec-inner">
                                    <div class="player-spec-search-row">
                                      <v-icon small color="#888">mdi-magnify</v-icon>
                                      <input class="player-spec-search-input" type="text" :placeholder="$t('searchPlayer') || 'Search player...'" :value="playerSpecifierSearchDetail[_detailPlayerKey(marketLines, _playerSide)] || ''" @input="$set(playerSpecifierSearchDetail, _detailPlayerKey(marketLines, _playerSide), $event.target.value)" />
                                    </div>
                                    <div class="player-spec-list">
                                      <div v-for="variant in getFilteredVariantsForTeamDetail(marketLines, object.event, _playerSide)" :key="variant.unique_id" class="player-spec-item" :class="{'active': getSelectedVariantDetail(marketLines, object.event, _playerSide) && String(variant.specifier) === String(getSelectedVariantDetail(marketLines, object.event, _playerSide).specifier)}" @click="selectPlayerSpecifierDetail(marketLines, variant.specifier, _playerSide)">{{ stripScoreState(variant.specifier) }}</div>
                                      <div v-if="getFilteredVariantsForTeamDetail(marketLines, object.event, _playerSide).length === 0" class="player-spec-empty">{{ $t('noResults') || 'No results' }}</div>
                                    </div>
                                  </div>
                                </v-menu>
                              </template>
                            </div>

                            <template v-for="_effSide in [getEffectivePlayerSide(marketLines, object.event)]">
                              <div class="player-filtered-container">
                                <div v-for="odd in getVisiblePlayerOutcomes(getPlayerOutcomesDetail(marketLines, object.event, _effSide), marketLines[0].unique_id)" :key="odd.unique_id" class="player-row-odd">
                                  <div v-if="odd.outcome_odd_value > 1 && odd.active" class="odd-cell compact player-cell" :class="getOddClasses(odd)" @click="putCart(getPlayerMarketForCartDetail(marketLines, object.event, _effSide), odd, object.event, object.sport, object.category, object.tournament)">
                                    <span class="odd_name">{{ odd.baseLine ? (odd.baseLine + ' - ') : '' }}{{ odd.outcome_alias || odd.outcome_name }}</span>
                                    <span v-if="getPlayerOutcomeLine(odd)" class="odd-line-val">{{ getPlayerOutcomeLine(odd) }}</span>
                                    <span class="odd_value">{{ odd.outcome_odd_value | odds_type_filter }}
                                      <OddBoostBadge :odd="odd" size="sm" :show-percent="false"/></span>
                                  </div>
                                  <div v-else class="odd-cell compact locked player-cell"><v-icon size="12" color="#555">mdi-lock</v-icon></div>
                                </div>
                                <template v-if="!isSpecifierPlayerMarket(marketLines) && getSplitPlayerOutcomes(marketLines[0], object.event).other.length > 0">
                                  <div v-for="odd in getVisiblePlayerOutcomes(getSplitPlayerOutcomes(marketLines[0], object.event).other, marketLines[0].unique_id + '_other')" :key="odd.unique_id" class="player-row-odd">
                                    <div v-if="odd.outcome_odd_value > 1 && odd.active" class="odd-cell compact player-cell" :class="getOddClasses(odd)" @click="putCart(marketLines[0], odd, object.event, object.sport, object.category, object.tournament)">
                                      <span class="odd_name">{{ odd.baseLine ? (odd.baseLine + ' - ') : '' }}{{ odd.outcome_alias || odd.outcome_name }}</span>
                                      <span v-if="getPlayerOutcomeLine(odd)" class="odd-line-val">{{ getPlayerOutcomeLine(odd) }}</span>
                                      <span class="odd_value">{{ odd.outcome_odd_value | odds_type_filter }}
                                        <OddBoostBadge :odd="odd" size="sm" :show-percent="false"/></span>
                                    </div>
                                    <div v-else class="odd-cell compact locked player-cell"><v-icon size="12" color="#555">mdi-lock</v-icon></div>
                                  </div>
                                </template>
                              </div>
                              <div v-if="getPlayerOutcomesDetail(marketLines, object.event, _effSide).length > playerDisplayLimit" class="show-more-toggle" @click.stop="togglePlayerExpansion(marketLines[0].unique_id)">
                                <span v-if="!isPlayerExpanded(marketLines[0].unique_id)">{{ $t('showMore') || 'Show More' }} <v-icon x-small color="var(--color-accent)">mdi-chevron-down</v-icon></span>
                                <span v-else>{{ $t('showLess') || 'Show Less' }} <v-icon x-small color="var(--color-accent)">mdi-chevron-up</v-icon></span>
                              </div>
                            </template>
                          </div>

                          <div v-else-if="isCompact(marketLines[0]) && isCorrectScoreMarket(marketLines[0])" class="cs-dedicated-body">
                            <div class="cs-teams-container">
                              <div class="cs-team-col">
                                <span class="cs-team-label">{{ object.event.home }}</span>
                                <div class="cs-stepper">
                                  <button class="cs-step-btn" @click.stop="updatePickerScore(marketLines[0], 'h', -1)">
                                    <v-icon color="var(--color-accent)">mdi-minus</v-icon>
                                  </button>
                                  <span class="cs-step-val">{{ scorePickers[marketLines[0].unique_id] ? scorePickers[marketLines[0].unique_id].h : 0 }}</span>
                                  <button class="cs-step-btn" :disabled="isMaxScoreReached(marketLines[0], 'h')" @click.stop="updatePickerScore(marketLines[0], 'h', 1)">
                                    <v-icon color="var(--color-accent)">mdi-plus</v-icon>
                                  </button>
                                </div>
                              </div>
                              <div class="cs-team-col">
                                <span class="cs-team-label">{{ object.event.away }}</span>
                                <div class="cs-stepper">
                                  <button class="cs-step-btn" @click.stop="updatePickerScore(marketLines[0], 'a', -1)">
                                    <v-icon color="var(--color-accent)">mdi-minus</v-icon>
                                  </button>
                                  <span class="cs-step-val">{{ scorePickers[marketLines[0].unique_id] ? scorePickers[marketLines[0].unique_id].a : 0 }}</span>
                                  <button class="cs-step-btn" :disabled="isMaxScoreReached(marketLines[0], 'a')" @click.stop="updatePickerScore(marketLines[0], 'a', 1)">
                                    <v-icon color="var(--color-accent)">mdi-plus</v-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="cs-odd-col">
                              <template v-for="csOdd in [getCorrectScoreOdd(marketLines[0], object.event)]">
                                <button v-if="csOdd && csOdd.outcome_odd_value > 1 && csOdd.active" :key="csOdd.unique_id" class="cs-odd-btn" :class="getOddClasses(csOdd)" @click="putCart(marketLines[0], csOdd, object.event, object.sport, object.category, object.tournament)">
                                  {{ csOdd.outcome_odd_value | odds_type_filter }}
                                  <OddBoostBadge :odd="csOdd" size="sm" :show-percent="false"/>
                                </button>
                                <button v-else-if="csOdd" :key="'locked_'+marketLines[0].unique_id" class="cs-odd-btn locked">
                                  <v-icon small color="#888">mdi-lock</v-icon>
                                </button>
                                <button v-else :key="'na_'+marketLines[0].unique_id" class="cs-odd-btn locked" @click="toggleCompactMode(marketLines[0], object.event)">
                                  <v-icon small color="#888">mdi-lock</v-icon>
                                </button>
                              </template>
                            </div>
                          </div>

                          <div v-else-if="isCompact(marketLines[0])" class="compact-view-wrapper">
                            <template v-for="selectedMarket in [getSelectedMarketLine(marketLines)]">
                              <div class="odds-flex-row" :key="'compact_' + selectedMarket.unique_id" :style="getUnifiedGridStyle(selectedMarket.outcome.length)" :data-cols="getGridCols(selectedMarket.outcome.length)" :class="{ multirow: selectedMarket.outcome.length > 3 }">
                                <div v-for="odd in selectedMarket.outcome" :key="odd.unique_id" class="odd-cell-wrapper">
                                  <div v-if="odd.outcome_odd_value > 1 && odd.active" class="odd-cell compact" :class="getOddClasses(odd)" @click="putCart(selectedMarket, odd, object.event, object.sport, object.category, object.tournament)">
                                    <div class="cell-content">
                                                                            <span class="outcome-label text-truncate">
                                                                                {{ getOutcomeName(object.event.competitors, odd, selectedMarket.unique_id) }}
                                                                                <span v-if="shouldShowOddLine(odd, selectedMarket)" class="odd-line-val" :class="getSpecifierType(odd.line) + '-text'">
                                                                                    {{ formatLineDisplay(odd.line, selectedMarket) }}
                                                                                </span>
                                                                                <span v-else-if="isEuropeanHandicapMarket(selectedMarket)" class="odd-line-val">
                                                                                    {{ formatHandicapSign(odd.outcome_name, selectedMarket.specifier) }}
                                                                                </span>
                                                                            </span>
                                      <span class="outcome-value">{{ odd.outcome_odd_value | odds_type_filter }}
                                        <OddBoostBadge :odd="odd" size="sm" :show-percent="false"/></span>
                                    </div>
                                  </div>
                                  <div v-else class="odd-cell compact locked"><v-icon size="12" color="#555">mdi-lock</v-icon></div>
                                </div>
                              </div>
                            </template>
                            <StepSlider
                                :steps="getPlayableLines(marketLines)"
                                :value="selectedSpecifiers[marketLines[0].id || marketLines[0].marketId]"
                                :formatLabel="getFormatLabelFn(marketLines[0])"
                                @input="selectSpecifier(marketLines[0].id || marketLines[0].marketId, $event)"
                            />
                          </div>

                          <div v-else>
                            <!-- Multi-line: scc table layout -->
                            <template v-if="marketLines.length > 1">
                              <div class="scc-line-row scc-outcomes-header"
                                   :style="getSccGridStyle(marketLines[0])">
                                <div class="scc-spec-cell scc-spec-label"></div>
                                <div class="scc-odd-header"
                                     v-for="name in getOutcomeColumnNames(marketLines[0])"
                                     :key="'hn_' + name">{{ name }}</div>
                              </div>
                              <div v-for="market in marketLines" :key="market.unique_id"
                                   class="scc-line-row"
                                   :style="getSccGridStyle(market)">
                                <div class="scc-spec-cell">
                                  <template v-if="hasValidSpecifier(market)">
                                    <span>{{ stripScoreState(market.specifier) }}</span>
                                  </template>
                                </div>
                                <div v-for="odd in market.outcome" :key="odd.unique_id" class="scc-odd-cell">
                                  <div v-if="odd.outcome_odd_value > 1 && odd.active"
                                       class="value clickable scc-value"
                                       :class="getOddClasses(odd)"
                                       @click="putCart(market, odd, object.event, object.sport, object.category, object.tournament)">
                                    {{ odd.outcome_odd_value | odds_type_filter }}
                                    <OddBoostBadge :odd="odd" size="sm"/>
                                  </div>
                                  <div v-else class="value locked scc-value"><v-icon size="12" color="var(--text-bg-cell)">mdi-lock</v-icon></div>
                                </div>
                              </div>
                            </template>

                            <!-- Single line: standard odds grid -->
                            <template v-else>
                              <div v-for="market in marketLines" :key="market.unique_id" class="market-row">
                                <div v-if="isOnlyCorrectScoreMarket(market)" class="correct-score-grid">
                                  <div v-for="(column, colIndex) in getCorrectScoreColumns(market.outcome)" :key="colIndex" class="correct-score-column">
                                    <div v-for="odd in column" :key="odd.unique_id" class="odd-cell-wrapper">
                                      <div v-if="odd.outcome_odd_value > 1 && odd.active" class="odd-cell compact" :class="getOddClasses(odd)" @click="putCart(market, odd, object.event, object.sport, object.category, object.tournament)">
                                        <div class="cell-content"><span class="outcome-label">{{ odd.outcome_name }}</span>
                                          <span class="outcome-value">{{ odd.outcome_odd_value | odds_type_filter }}
                                            <OddBoostBadge :odd="odd" size="sm" :show-percent="false"/></span></div>
                                      </div>
                                      <div v-else class="odd-cell compact locked"><v-icon size="12" color="#555">mdi-lock</v-icon></div>
                                    </div>
                                  </div>
                                </div>
                                <div v-else
                                     class="odds-flex-row"
                                     :style="getUnifiedGridStyle(market.outcome.length)"
                                     :data-cols="getGridCols(market.outcome.length)"
                                     :class="{ multirow: market.outcome.length > 3 }">
                                  <div v-for="odd in market.outcome" :key="odd.unique_id" class="odd-cell-wrapper">
                                    <div v-if="odd.outcome_odd_value > 1 && odd.active" class="odd-cell compact" :class="getOddClasses(odd)" @click="putCart(market, odd, object.event, object.sport, object.category, object.tournament)">
                                      <div class="cell-content">
                                        <span class="outcome-label text-truncate">
                                          {{ getOutcomeName(object.event.competitors, odd, market.unique_id) }}
                                          <span v-if="shouldShowOddLine(odd, market)" class="odd-line-val" :class="getSpecifierType(odd.line) + '-text'">{{ formatLineDisplay(odd.line, market) }}</span>
                                          <span v-else-if="isEuropeanHandicapMarket(market)" class="odd-line-val">{{ formatHandicapSign(odd.outcome_name, market.specifier) }}</span>
                                        </span>
                                        <span class="outcome-value">{{ odd.outcome_odd_value | odds_type_filter }}
                                          <OddBoostBadge :odd="odd" size="sm" :show-percent="false"/></span>
                                      </div>
                                    </div>
                                    <div v-else class="odd-cell compact locked"><v-icon size="12" color="#555">mdi-lock</v-icon></div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>

                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </template>
              </div>
            </div>
          </div>

          <div v-else class="empty-state">
            <v-icon large color="#444" class="mb-2">mdi-alert-circle-outline</v-icon>
            <span class="empty-text">{{ $t('noOddsForThisGroup') }}</span>
          </div>
        </div>
      </div>
    </transition-group>

    <div v-if="infoModal" class="mim-overlay" @click.self="infoModal = false">
      <div class="mim-panel" :class="{ 'mim-panel--mobile': isMobileOnly }">
        <div v-if="isMobileOnly" class="mim-drag-handle"></div>

        <div class="mim-header">
          <div class="mim-header-left">
            <span class="mim-market-name">{{ currentInfoMarket.alias || currentInfoMarket.name }}</span>
          </div>
          <button class="mim-close-btn" @click="infoModal = false">✕</button>
        </div>

        <div class="mim-body">
          <div v-if="loadingInfo" class="mim-loading">
            <v-progress-circular indeterminate color="#006039" size="28" width="2"></v-progress-circular>
          </div>
          <template v-else>
            <div class="mim-market-name-row" @click="showMarketId = !showMarketId">
              <div class="mim-section-label">{{ $t('marketDescription') || 'Description' }}</div>
              <span class="mim-market-id">ID {{ currentInfoMarket.id }}</span>
            </div>

            <div class="mim-desc-section" v-if="currentInfoMarket.desc">
              <p class="mim-desc-text">{{ currentInfoMarket.desc }}</p>
            </div>
            <div class="mim-desc-section mim-no-desc" v-else>
              <span>{{ $t('noDescriptionAvailable') || 'No description available' }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {isMobileOnly, isTablet} from "mobile-device-detect";
import _ from 'lodash';
import { resolveDefaultLine } from '@/utils/marketLineUtils';
import marketInfoMixin from '@/mixins/marketInfoMixin';
import pinnedMarketsMixin from '@/mixins/pinnedMarketsMixin';
import liveBetBuilderTabMixin from '@/mixins/liveBetBuilderTabMixin';
import LogoCompetitors from "@/components/center_widgets/LogoCompetitors.vue";
import ScoreboardLive from "@/components/center_widgets/Live/previews/ScoreboardLive.vue";
import QuickSelectEventLiveAmerican from "@/components/american/QuickSelectEventLiveAmerican.vue";
import TradeTracker from "@/components/center_widgets/Live/tradeTracker.vue";
import SmartToolbarAmerican from "@/components/american/SmartToolbarAmerican.vue";
import StepSlider from "@/components/generic/StepSlider.vue";
import IllinoisIcons from "@/components/american/icons.vue";
import LiveMatchTrackerAmerican from "@/components/american/LiveMatchTrackerAmerican.vue";
import OddBoostBadge from '@/components/generic/OddBoostBadge.vue';
import { MARKET_NOT_NAME_IN_OUTCOME } from '../../constants/marketConstants';

const EVENT_STATUS = { STARTING_SOON: '9' };
const CLOCK = { INVALID: '-1' };
const DRAW_OUTCOME_ID = '128';

const EUROPEAN_HANDICAP_MARKETS = {
  13: 'European Handicap',
  61: 'European Handicap Halftime',
  386: 'European Handicap',
  433: 'European Handicap Corners',
  935: 'European Cards Handicap',
  1691: 'European Handicap',
  1692: 'European Handicap',
  1693: 'European Handicap 2nd Period',
  1694: 'European Handicap 1st Period'
};

export default {
  name: 'LiveDetailV16American',
  components: {
    LiveMatchTrackerAmerican,
    IllinoisIcons,
    SmartToolbarAmerican,
    LogoCompetitors,
    ScoreboardLive,
    QuickSelectEventLiveAmerican,
    StepSlider,
    TradeTracker,
    OddBoostBadge,
  },
  mixins: [marketInfoMixin, pinnedMarketsMixin, liveBetBuilderTabMixin],
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    loading: false,
    groupSelected: null,
    tab_loading: false,
    object: null,
    marketsLimit: 15,
    trackerExpanded: false,
    categoryPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/categories/round_flags/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons-color/',
    sportBackgroundPath: process.env.VUE_APP_URL_CLOUDFRONT +'/svg/sports-bg/',
    light: (window.icons == 'light'),
    oddsVisualMode: 'blink',
    searchQuery: '',
    compactModes: {},
    selectedSpecifiers: {},
    openSpecifierDropdowns: {},
    expandedPlayerMarkets: {},
    selectedPlayerTeam: {},
    playerDisplayLimit: 5,
    playerSpecifierMenuOpen: {},
    playerSpecifierSearchDetail: {},
    playerSelectedSpecifierDetail: {},
    panelsState: {},
    scorePickers: {},
    isModalOpen: false,
    selectedEventForModal: null,
    isSmallScreen: false,
    colToShow: [0],
    availableMarketsLoaded: false,
    showMarketSearchDropdown: false,
    searchModeContext: null,
    tooltip: { visible: false, text: '', x: 0, y: 0 },
    loadingInfo: false,
    infoModal: false,
    currentInfoMarket: {},
  }),
  created() {
    this._trackerSizeHandler = val => { this.trackerExpanded = val; };
    this.$root.$on('toggle-tracker-size', this._trackerSizeHandler);
  },
  computed: {
    ...mapGetters({
      'getEventsLiveDetail': 'detailLive/getEventsLiveDetail',
      'getLoadingDetail': 'detailLive/getLoadingDetail',
      'getMarketsGroupsDetailLive': 'detailLive/getMarketsGroupsDetailLive',
      'getOddsSources': 'cart/getOddsSources',
      'getLanguage': 'settings/getLanguage',
      'getMarketConfig': 'settings/getMarketConfig',
      'getAvailableMarketsLive': 'detailLive/getAvailableMarketsLive',
      'getLivePollingIntervalMs': 'settings/getLivePollingIntervalMs',
      'getCompetitorsInOutcome': 'settings/getCompetitorsInOutcome',
    }),
    filteredAvailableMarkets() {
      if (!this.searchQuery) return [];
      const words = this.searchQuery.toLowerCase().split(/\s+/).filter(Boolean);
      return this.getAvailableMarketsLive
          .filter(m => { const n = m.marketName.toLowerCase(); return words.every(w => n.includes(w)); })
          .slice(0, 10);
    },
    filteredGroups() {
      const allGroups = this.withLiveBetBuilderGroup(this.getMarketsGroupsDetailLive || []);
      const base = this.pinnedMarkets.length
          ? [{ _id: 'favourites', name: this.$t('favourites') || 'Favourites', icon: 'mdi-star' }, ...allGroups]
          : allGroups;
      if (!this.searchQuery) return base;
      const q = this.searchQuery.toLowerCase();
      return base.filter(g => (g.name || 'all').toLowerCase().includes(q));
    },
    processedMarketsForDetail() {
      if (!this.object || !this.object.event || !this.object.event.odds) return [];
      let result = this.object.event.odds;
      if (this.groupSelected === 'favourites') {
        result = result.filter(lines => this.isPinned(lines[0]));
      }
      if (this.searchQuery) {
        const words = this.searchQuery.toLowerCase().split(/\s+/).filter(Boolean);
        result = result.filter(lines => { const n = lines[0].marketName.toLowerCase(); return words.every(w => n.includes(w)); });
      }
      const sorted = result.slice().sort((a, b) => {
        const idA = a[0].id || a[0].marketId;
        const idB = b[0].id || b[0].marketId;
        const idxA = this.pinnedMarkets.indexOf(idA);
        const idxB = this.pinnedMarkets.indexOf(idB);
        const pinA = idxA !== -1;
        const pinB = idxB !== -1;
        if (pinA && !pinB) return -1;
        if (!pinA && pinB) return 1;
        if (pinA && pinB) return idxA - idxB;

        return 0;
      });
      return sorted.slice(0, this.marketsLimit);
    },
    expansionAllOpen() {
      const markets = this.processedMarketsForDetail;
      return markets.length > 0 && markets.every(g => this.panelsState[g[0].unique_id] === 0);
    },

  },
  methods: {
    ...mapActions({
      'removeEventLiveDetail': 'detailLive/removeEventLiveDetail',
      'fetchOddsGroupDetailLiveV3': 'detailLive/fetchOddsGroupDetailLiveV3',
      'fetchFavouriteMarketsLiveDetail': 'detailLive/fetchFavouriteMarketsLiveDetail',
      'fetchBetBuilderMarketsLive': 'detailLive/fetchBetBuilderMarketsLive',
      'fetchAvailableMarketsLive': 'detailLive/fetchAvailableMarketsLive',
      'setLoadingDetail': 'detailLive/setLoadingDetail',
      'addOddToCartV3': 'cart/addOddToCartV3'
    }),

    isEuropeanHandicapMarket(market) {
      if (!market) return false;
      const marketId = String(market.id || market.marketId);
      return Object.prototype.hasOwnProperty.call(EUROPEAN_HANDICAP_MARKETS, marketId);
    },

    shouldShowOddLine(odd, market) {
      if (!odd.line) return false;
      if (this.isEuropeanHandicapMarket(market)) return false;
      return true;
    },

    formatHandicapSign(outcomeName, specifier) {
      if (!specifier || !specifier.includes(':')) return '';
      const parts = specifier.split(':');
      const homeGoals = parseInt(parts[0], 10);
      const awayGoals = parseInt(parts[1], 10);
      const netHome = homeGoals - awayGoals;
      const netAway = awayGoals - homeGoals;

      if (outcomeName === '1') {
        return netHome > 0 ? `+${netHome}` : `${netHome}`;
      } else if (outcomeName === '2' || outcomeName === 'X' || outcomeName.toLowerCase() === 'x') {
        return netAway > 0 ? `+${netAway}` : `${netAway}`;
      }
      return '';
    },

    getCorrectScoreColumns(outcomes) {
      const home = [];
      const draw = [];
      const away = [];

      outcomes.forEach(odd => {
        const score = odd.outcome_name || odd.name;
        const match = score.match(/^(\d+)-(\d+)$/);

        if (!match) return;

        const h = parseInt(match[1], 10);
        const a = parseInt(match[2], 10);

        if (h > a) {
          home.push(odd);
        } else if (h === a) {
          draw.push(odd);
        } else {
          away.push(odd);
        }
      });

      // ordinamento verticale
      home.sort((x, y) => {
        const [xh] = x.outcome_name.split('-').map(Number);
        const [yh] = y.outcome_name.split('-').map(Number);
        return xh - yh;
      });

      draw.sort((x, y) => {
        const [xh] = x.outcome_name.split('-').map(Number);
        const [yh] = y.outcome_name.split('-').map(Number);
        return xh - yh;
      });

      away.sort((x, y) => {
        const [, xa] = x.outcome_name.split('-').map(Number);
        const [, ya] = y.outcome_name.split('-').map(Number);
        return xa - ya;
      });

      return [home, draw, away];
    },


    isAboutToStart(event) {
      return event.status === EVENT_STATUS.STARTING_SOON;
    },
    onSearchQueryUpdate(val) {
      this.searchQuery = val;
    },
    styleMatchHero(sportId){

    },
    getSportBg(sportId) {
      return `${process.env.VUE_APP_URL_CLOUDFRONT}/svg/sports-bg-detail/${sportId}.webp`;
    },

    // --- LOGICA BADGES E HANDICAP ---
    getSpecifierType(specifier) {
      if (!specifier) return 'neutral';
      const str = String(specifier).trim();
      if (str.startsWith('-')) return 'negative';
      if (str.startsWith('+')) return 'positive';
      return 'neutral';
    },

    // --- CUSTOM SPECIFIER DROPDOWN ---
    getSelectedLineForDropdown(marketLines) {
      const marketId = marketLines[0].id || marketLines[0].marketId;
      const selectedUid = this.selectedSpecifiers[marketId];
      const lines = this.getPlayableLines(marketLines);
      return lines.find(l => l.unique_id === selectedUid) || lines[0] || null;
    },
    toggleSpecifierDropdown(marketId) {
      const isOpen = !!this.openSpecifierDropdowns[marketId];
      this.openSpecifierDropdowns = {};
      if (!isOpen) this.$set(this.openSpecifierDropdowns, marketId, true);
    },
    closeSpecifierDropdown(marketId) {
      this.$set(this.openSpecifierDropdowns, marketId, false);
    },
    closeAllSpecifierDropdowns() {
      this.openSpecifierDropdowns = {};
    },
    selectSpecifier(marketId, uniqueId) {
      this.$set(this.selectedSpecifiers, marketId, uniqueId);
      this.$set(this.openSpecifierDropdowns, marketId, false);
    },

    // --- PLAYER MARKET EXPANSION ---
    togglePlayerExpansion(uniqueId) {
      this.$set(this.expandedPlayerMarkets, uniqueId, !this.expandedPlayerMarkets[uniqueId]);
    },
    isPlayerExpanded(uniqueId) {
      return !!this.expandedPlayerMarkets[uniqueId];
    },
    getVisiblePlayerOutcomes(outcomes, uniqueId) {
      if (!outcomes) return [];
      if (this.isPlayerExpanded(uniqueId)) return outcomes;
      return outcomes.slice(0, this.playerDisplayLimit);
    },
    getSelectedPlayerTeam(uniqueId) {
      return this.selectedPlayerTeam[uniqueId] || 'home';
    },
    setSelectedPlayerTeam(uniqueId, team) {
      this.$set(this.selectedPlayerTeam, uniqueId, team);
      this.$set(this.expandedPlayerMarkets, uniqueId, false);
    },

    // Returns true only when both teams have at least one playable player outcome
    _detailBothSidesHaveData(marketLines, event) {
      return this.getPlayerOutcomesDetail(marketLines, event, 'home').length > 0
          && this.getPlayerOutcomesDetail(marketLines, event, 'away').length > 0;
    },
    // Auto-falls-back to the team that has data when the selected side is empty
    getEffectivePlayerSide(marketLines, event) {
      const selected = this.getSelectedPlayerTeam(marketLines[0].unique_id);
      if (this.getPlayerOutcomesDetail(marketLines, event, selected).length > 0) return selected;
      const other = selected === 'home' ? 'away' : 'home';
      return this.getPlayerOutcomesDetail(marketLines, event, other).length > 0 ? other : selected;
    },

    hasHiddenPlayers(market, event, team) {
      const split = this.getSplitPlayerOutcomes(market, event);
      if (team === 'home' || team === 'away') {
        return split[team].length > this.playerDisplayLimit;
      }
      return split.home.length > this.playerDisplayLimit ||
          split.away.length > this.playerDisplayLimit ||
          split.other.length > this.playerDisplayLimit;
    },

    isHandicapMarket(market) {
      if (!market) return false;
      const id = parseInt(market.id || market.marketId, 10);
      return this.getMarketConfig.handicapIds.includes(id);
    },

    stripScoreState(str) {
      if (!str) return str;
      return String(str).replace(/\s*\(\d+-\d+\)\s*$/, '').trim();
    },

    formatLineDisplay(line, market) {
      if (!line) return '';
      let str = this.stripScoreState(String(line).trim());

      if (this.isHandicapMarket(market)) {
        if (/^[0-9]/.test(str) && parseFloat(str) !== 0) {
          return '+' + str;
        }
      }
      return str;
    },

    onResize() {
      const w = window.innerWidth;
      this.isSmallScreen = w <= 600;
    },
    showTooltip(e, text) {
      this.tooltip.text = text;
      this.tooltip.visible = true;
      this.tooltip.x = e.clientX + 15;
      this.tooltip.y = e.clientY + 15;
    },
    updateTooltipPos(e) {
      if (this.tooltip.visible) {
        this.tooltip.x = e.clientX + 15;
        this.tooltip.y = e.clientY + 15;
      }
    },
    hideTooltip() {
      this.tooltip.visible = false;
    },

    openModal(event) {
      this.selectedEventForModal = event;
      this.isModalOpen = true;
    },

    onSelectGroup(id) {
      if (id !== this.groupSelected) {
        const {event, sport, category, tournament} = this.object;
        this.changeGroup(event.id, id, sport.id, category.id, tournament.id);
      }
    },

    getOutcomeName(c, o, unique_id) {

      if (MARKET_NOT_NAME_IN_OUTCOME.includes(unique_id)) {
        return o.outcome_alias || o.outcome_name;
      }

      const outcome = o.outcome_name?.toLowerCase();

      if (o.outcome_name === 'X') {
        return o.outcome_alias || o.outcome_name;
      }

      if (this.getCompetitorsInOutcome) {
        if (outcome === 'local') {
          return c?.[0]?.name || o.outcome_alias || o.outcome_name;
        }

        if (outcome === 'visitante') {
          return c?.[1]?.name || o.outcome_alias || o.outcome_name;
        }

        if ((o.outcome_name === "1" || o.outcome_name === "2") && unique_id != DRAW_OUTCOME_ID) {
          for (let i = 0; i < c.length; i++) {
            if (c[i].position === o.outcome_name) {
              return c[i].name;
            }
          }
        }
      }

      return o.outcome_alias || o.outcome_name;
    },

    closeDetail(object) {
      this.removeEventLiveDetail(object.event.id);
      // Clear deep-link globals so SportCenterRouter.isDeepLinkPending
      // does not treat the now-empty store as a pending load.
      window.eventId      = null;
      window.tournamentId = null;
    },

    async changeGroup(eventId, groupId, sport, category, tournament) {
      if (groupId != this.groupSelected) {
        this.groupSelected = groupId;
        this.tab_loading = true;

        this.marketsLimit = 15;
        this.panelsState = {};
        this.compactModes = {};
        this.selectedSpecifiers = {};
        this.openSpecifierDropdowns = {};
        this.expandedPlayerMarkets = {};
        this.selectedPlayerTeam = {};
        this.scorePickers = {};

        if (groupId === 'favourites') {
          await this.fetchFavouriteMarketsLiveDetail({ source: eventId, sport, tournament });
        } else if (groupId === 'betbuilder') {
          await this.fetchBetBuilderMarketsLive({ source: eventId, sport, category, tournament });
        } else {
          await this.fetchOddsGroupDetailLiveV3({
            'source': eventId, 'group': groupId, 'sport': sport, 'tournament': tournament
          });
        }

        if (this.getEventsLiveDetail && this.getEventsLiveDetail.length > 0) {
          this.object = this.getEventsLiveDetail[0];
          this.initPanels(this.object.event.odds);
        }

        this.tab_loading = false;

        setTimeout(() => {
          this.marketsLimit = 1000;
        }, 150);
      }
    },

    getPlayerOutcomeLine(odd) {
      if (!odd.line) return null;
      if (odd.baseLine) {
        if (odd.line === odd.baseLine) return null;
        if (odd.line.startsWith(odd.baseLine + '#')) {
          return odd.line.slice(odd.baseLine.length + 1);
        }
      }
      return odd.line.replace('#', ' · ');
    },

    isPlayerMarket(market) {
      if (!market) return false;
      if (market.isPlayerMarket) return true;
      if (!market.outcome || market.outcome.length === 0) return false;
      const o = market.outcome[0];
      return (o.partecipantId !== null && o.partecipantId !== undefined) ||
          (o.participantId !== null && o.participantId !== undefined);
    },

    getSplitPlayerOutcomes(market, event) {
      const homeId = String(event.home_id);
      const awayId = String(event.away_id);
      let homeOdds = [], awayOdds = [], otherOdds = [];
      market.outcome
          .filter(odd => odd.active && parseFloat(odd.outcome_odd_value) > 1)
          .forEach(odd => {
            const pId = String(odd.partecipantId || odd.participantId);
            if (pId === homeId) homeOdds.push(odd);
            else if (pId === awayId) awayOdds.push(odd);
            else otherOdds.push(odd);
          });
      return { home: homeOdds, away: awayOdds, other: otherOdds };
    },

    // --- SPECIFIER PLAYER MARKET (one market entry per player, e.g. basketball) ---
    isSpecifierPlayerMarket(marketLines) {
      if (!marketLines || marketLines.length <= 1) return false;
      const first = marketLines[0];
      if (!first.outcome || !first.outcome.length) return false;
      const o = first.outcome[0];
      return (o.partecipantId != null || o.participantId != null) && first.specifier != null && String(first.specifier).trim() !== '';
    },
    _detailPlayerKey(marketLines, side) {
      return `${String(marketLines[0]?.id || marketLines[0]?.unique_id)}_${side}`;
    },
    getVariantsForTeamDetail(marketLines, event, teamId) {
      return marketLines.filter(ml => {
        if (!ml.outcome || !ml.outcome.length) return false;
        const pId = String(ml.outcome[0].partecipantId || ml.outcome[0].participantId || '');
        return pId === String(teamId);
      });
    },
    getSelectedVariantDetail(marketLines, event, side) {
      const teamId = side === 'home' ? event.home_id : event.away_id;
      const variants = this.getVariantsForTeamDetail(marketLines, event, teamId);
      if (!variants.length) return null;
      const key = this._detailPlayerKey(marketLines, side);
      const sel = this.playerSelectedSpecifierDetail[key];
      if (sel) {
        const found = variants.find(v => String(v.specifier) === String(sel));
        if (found) return found;
      }
      return variants[0];
    },
    getSelectedPlayerLabelDetail(marketLines, event, side) {
      const v = this.getSelectedVariantDetail(marketLines, event, side);
      return v ? v.specifier : '—';
    },
    getFilteredVariantsForTeamDetail(marketLines, event, side) {
      const teamId = side === 'home' ? event.home_id : event.away_id;
      const variants = this.getVariantsForTeamDetail(marketLines, event, teamId);
      const q = (this.playerSpecifierSearchDetail[this._detailPlayerKey(marketLines, side)] || '').trim().toLowerCase();
      if (!q) return variants;
      return variants.filter(v => String(v.specifier || '').toLowerCase().includes(q));
    },
    selectPlayerSpecifierDetail(marketLines, specifier, side) {
      const key = this._detailPlayerKey(marketLines, side);
      this.$set(this.playerSelectedSpecifierDetail, key, specifier);
      this.$set(this.playerSpecifierMenuOpen, key, false);
      this.$set(this.playerSpecifierSearchDetail, key, '');
    },
    getPlayerOutcomesDetail(marketLines, event, side) {
      if (!this.isSpecifierPlayerMarket(marketLines)) {
        return this.getSplitPlayerOutcomes(marketLines[0], event)[side];
      }
      const variant = this.getSelectedVariantDetail(marketLines, event, side);
      return variant ? variant.outcome.filter(o => o.active && parseFloat(o.outcome_odd_value) > 1) : [];
    },
    getPlayerMarketForCartDetail(marketLines, event, side) {
      if (!this.isSpecifierPlayerMarket(marketLines)) return marketLines[0];
      return this.getSelectedVariantDetail(marketLines, event, side) || marketLines[0];
    },

    getPlayableLines(marketLines) {
      if (!marketLines) return [];
      return marketLines.filter(line =>
          line.outcome && line.outcome.some(o => o.outcome_odd_value > 1 && o.active)
      );
    },

    getFormatLabelFn(market) {
      return (item) => this.formatLineDisplay(item.specifier, market);
    },

    isCompact(market) {
      const mId = market.id || market.marketId;
      return !!this.compactModes[mId];
    },
    toggleCompactMode(market, event) {
      const mId = market.id || market.marketId;
      this.$set(this.compactModes, mId, !this.compactModes[mId]);
      if (this.compactModes[mId]) {
        if (this.isCorrectScoreMarket(market)) this.initScorePicker(market.unique_id, event, market);
        else if (!this.selectedSpecifiers[mId]) {
          const marketLines = this.object.event.odds.find(
              l => l && l.length > 0 && String(l[0].id || l[0].marketId) === String(mId)
          );
          const defaultLine = resolveDefaultLine(marketLines || []);
          if (defaultLine) this.$set(this.selectedSpecifiers, mId, defaultLine.unique_id);
        }
      }
    },

    getSelectedMarketLine(marketLines) {
      const mId = marketLines[0].id || marketLines[0].marketId;
      const selectedId = this.selectedSpecifiers[mId];
      return marketLines.find(m => m.unique_id === selectedId) || this.getPlayableLines(marketLines)[0] || marketLines[0];
    },

    isCorrectScoreMarket(market) {
      if (!market) return false;
      const id = parseInt(market.id || market.marketId);
      if (this.getMarketConfig.correctScoreIds.includes(id)) return true;
      const name = (market.marketName || '').toLowerCase();
      return name.includes('correct score') || name.includes('risultato esatto');
    },

    isOnlyCorrectScoreMarket(market) {
      if (!market) return false;
      const id = parseInt(market.id || market.marketId, 10);
      return this.getMarketConfig.onlyCorrectScoreIds.includes(id);
    },

    hasValidSpecifier(market) {
      return market.specifier && market.specifier !== '' && market.specifier !== 'noSpec';
    },

    getLiveScore(event) {
      const sb = event?.livescore?.scoreboard || event?.Livescore?.Scoreboard || event?.Livescore?.scoreboard;
      const results = sb?.Results || sb?.results || [];
      const h = results.find(r => String(r.Position || r.position) === '1');
      const a = results.find(r => String(r.Position || r.position) === '2');
      return { h: parseInt(h?.Value ?? h?.value ?? 0), a: parseInt(a?.Value ?? a?.value ?? 0) };
    },
    // Estrae {h, a} dal nome di un outcome correct score (es. "2-3", "2:3", "2 - 3").
    _parseScoreFromName(name) {
      if (!name) return null;
      const m = String(name).match(/(\d+)\s*[-:]\s*(\d+)/);
      return m ? { h: parseInt(m[1]), a: parseInt(m[2]) } : null;
    },

    // Inizializza il picker per un market correct score.
    // - event.isOvertime → si riparte da 0-0 (i market ET hanno il loro score azzerate)
    // - altrimenti → score corrente del match
    // - se il market è passato (market param), verifica che lo score target abbia una quota
    //   giocabile; se no, scende in fallback alla prima quota utile disponibile.
    initScorePicker(marketId, event, market = null) {
      if (this.scorePickers[marketId]) return;

      const isOT = !!(event && event.isOvertime);
      const targetScore = (event && !isOT) ? this.getLiveScore(event) : { h: 0, a: 0 };

      if (market && market.outcome && market.outcome.length > 0) {
        // Controlla se lo score target ha una quota giocabile
        const sa = `${targetScore.h}-${targetScore.a}`;
        const sb = `${targetScore.h}:${targetScore.a}`;
        const sc = `${targetScore.h} - ${targetScore.a}`;
        const targeted = market.outcome.find(o =>
            o.name.includes(sa) || o.name.includes(sb) || o.name.includes(sc)
        );
        if (targeted && targeted.active && parseFloat(targeted.outcome_odd_value) > 1) {
          this.$set(this.scorePickers, marketId, { h: targetScore.h, a: targetScore.a });
          return;
        }
        // Fallback: prima quota giocabile, si ricava lo score dal nome
        const fallback = market.outcome.find(o => o.active && parseFloat(o.outcome_odd_value) > 1);
        if (fallback) {
          const parsed = this._parseScoreFromName(fallback.name);
          if (parsed) {
            this.$set(this.scorePickers, marketId, parsed);
            return;
          }
        }
      }

      // Default: score target (0-0 per OT, score attuale per regular)
      this.$set(this.scorePickers, marketId, { h: targetScore.h, a: targetScore.a });
    },
    isMaxScoreReached(market, team) {
      const currentScore = this.scorePickers[market.unique_id] ? this.scorePickers[market.unique_id][team] : 0;
      return currentScore >= 9;
    },
    _findOpenScore(market, team, startVal, delta) {
      const otherTeam = team === 'h' ? 'a' : 'h';
      const otherScore = this.scorePickers[market.unique_id][otherTeam];
      let val = startVal;
      while (val >= 0 && val <= 9) {
        const testH = team === 'h' ? val : otherScore;
        const testA = team === 'a' ? val : otherScore;
        const searchA = `${testH}-${testA}`;
        const searchB = `${testH}:${testA}`;
        const searchC = `${testH} - ${testA}`;
        const odd = market.outcome.find(o => o.name.includes(searchA) || o.name.includes(searchB) || o.name.includes(searchC));
        if (odd && odd.active && odd.outcome_odd_value > 1) return val;
        val += delta;
      }
      return null;
    },
    updatePickerScore(market, team, delta) {
      this.initScorePicker(market.unique_id);
      const current = this.scorePickers[market.unique_id][team];
      const newVal = current + delta;
      if (newVal >= 0 && newVal <= 9) this.$set(this.scorePickers[market.unique_id], team, newVal);
    },
    getCorrectScoreOdd(market, event) {
      this.initScorePicker(market.unique_id || market.id, event, market);
      const scores = this.scorePickers[market.unique_id || market.id];
      const searchA = `${scores.h}-${scores.a}`;
      const searchB = `${scores.h}:${scores.a}`;
      const searchC = `${scores.h} - ${scores.a}`;
      return market.outcome.find(o => o.name.includes(searchA) || o.name.includes(searchB) || o.name.includes(searchC));
    },

    getGridCols(outcomesCount) {
      if (this.isMobileOnly) {
        return outcomesCount === 2 ? 2 : 3;
      }
      if (outcomesCount === 2) return 2;
      if (outcomesCount === 4) return 2;
      return 3;
    },
    getSccGridStyle(market) {
      const cols = market.outcome ? market.outcome.length : 2;
      return { 'grid-template-columns': `1fr ${Array(cols).fill('1.5fr').join(' ')}` };
    },
    getOutcomeColumnNames(market) {
      if (market.outcomeNames && market.outcomeNames.length) return market.outcomeNames;
      if (market.outcome && market.outcome.length) return market.outcome.map(o => o.outcome_alias || o.outcome_name || '');
      return [];
    },
    getUnifiedGridStyle(outcomesCount) {
      const cols = this.getGridCols(outcomesCount);
      return { 'display': 'grid', 'grid-template-columns': `repeat(${cols}, minmax(0, 1fr))`, 'gap': '0px', 'width': '100%' };
    },
    getOddClasses(odd) {
      const classes = [];
      if (this.getOddsSources.includes(odd.unique_id)) classes.push('odd_selected');
      if (this.oddsVisualMode === 'blink') {
        if (odd.type_change === 'up') classes.push('odd_blink_up');
        else if (odd.type_change === 'down') classes.push('odd_blink_down');
      }
      return classes;
    },
    async putCart(oddMarket, odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 1 && odd.active) {
        await this.addOddToCartV3({ oddMarket, odd, event, sport, category, tournament, type: 'live' });
        this.$root.$emit('forceUpdateSingleMultiple');
      }
    },
    hasTime(event) { return event?.livescore?.scoreboard?.time && event.livescore.scoreboard.time !== '-1'; },
    hasPeriod(event) { return event?.livescore?.scoreboard?.currentPeriod; },
    getInfoTimeMatch(livescore, sport, status) {
      // Check livescore first: it's updated by socket and reflects the true in-play state.
      if (status === EVENT_STATUS.STARTING_SOON || !livescore || !livescore.scoreboard || livescore.scoreboard.currentPeriod === CLOCK.INVALID) { return this.$t('periods.about_to_start'); }

      if (livescore && livescore.scoreboard && livescore.scoreboard.currentPeriod) {
        return this.$t('periods.' + sport + '.' + livescore.scoreboard.currentPeriod);
      }

      return '';
    },
    getMatchCurrentTime(time) {
      if (time === undefined || time === null || time === '') return '';
      const timeNum = parseInt(time, 10);
      if (isNaN(timeNum) || timeNum < 0) return '';
      var minutes = Math.floor(timeNum / 60);
      var seconds = timeNum - minutes * 60;
      return (seconds < 10) ? minutes + ':0' + seconds : minutes + ':' + seconds;
    },
    getMatchCurrentPeriod(period) {
      if (!period) return '';
      if (Array.isArray(period)) {
        var find = _.find(period, {'lang': this.getLanguage}) || _.find(period, {'lang': 'en'});
        return find ? find.text : '';
      }
      return '';
    },
    initPanels(odds) {
      const limit = 10;
      if(odds) {
        // Ordiniamo le quote nello stesso modo in cui fa processedMarketsForDetail per coerenza
        let result = [...odds];
        if (this.groupSelected === 'favourites') {
          result = result.filter(lines => this.isPinned(lines[0]));
        }
        if (this.searchQuery) {
          const words = this.searchQuery.toLowerCase().split(/\s+/).filter(Boolean);
          result = result.filter(lines => { const n = lines[0].marketName.toLowerCase(); return words.every(w => n.includes(w)); });
        }
        result.sort((a, b) => {
          const idA = a[0].id || a[0].marketId;
          const idB = b[0].id || b[0].marketId;
          const idxA = this.pinnedMarkets.indexOf(idA);
          const idxB = this.pinnedMarkets.indexOf(idB);
          if (idxA !== -1 && idxB === -1) return -1;
          if (idxA === -1 && idxB !== -1) return 1;
          if (idxA !== -1 && idxB !== -1) return idxA - idxB;
          return 0;
        });

        result.forEach((lines, index) => {
          const mId = lines[0].id || lines[0].marketId;
          const uniqueId = lines[0].unique_id;

          if (this.panelsState[uniqueId] === undefined) {
            const targetState = index < limit ? 0 : undefined;
            this.$set(this.panelsState, uniqueId, targetState);
          }

          if (this.isCorrectScoreMarket(lines[0])) {
            if (this.compactModes[mId] === undefined) {
              this.$set(this.compactModes, mId, true);
            }
            if(this.isCorrectScoreMarket(lines[0])) {
              this.initScorePicker(uniqueId, this.object?.event, lines[0]);
            } else {
              if (!this.selectedSpecifiers[mId]) {
                const defaultLine = resolveDefaultLine(lines);
                if (defaultLine) this.$set(this.selectedSpecifiers, mId, defaultLine.unique_id);
              }
            }
          }
        });
      }
    },
    toggleAll() {
      const markets = this.processedMarketsForDetail;
      const allOpen = markets.every(g => this.panelsState[g[0].unique_id] === 0);
      markets.forEach(group => {
        const id = group[0].unique_id;
        this.$set(this.panelsState, id, allOpen ? null : 0);
      });
    },
    changeCol(col){
      this.colToShow = col
    },

    async _loadAvailableMarkets() {
      if (!this.object) return;
      this.availableMarketsLoaded = true;
      try {
        await this.fetchAvailableMarketsLive({ source: this.object.event.id, sport: this.object.sport.id });
      } catch {
        this.availableMarketsLoaded = false;
      }
    },

    async selectMarketFromSearch(market, object) {
      if (!this.searchModeContext) {
        const currentGroup = this.getMarketsGroupsDetailLive
            ? this.getMarketsGroupsDetailLive.find(g => g._id === this.groupSelected)
            : null;
        this.searchModeContext = {
          groupId: this.groupSelected,
          groupName: currentGroup ? currentGroup.name : '←'
        };
      }
      this.searchQuery = '';
      this.showMarketSearchDropdown = false;
      this.tab_loading = true;
      this.panelsState = {};
      this.compactModes = {};
      this.selectedSpecifiers = {};
      this.scorePickers = {};
      this.expandedPlayerMarkets = {};
      this.selectedPlayerTeam = {};
      this.playerSpecifierMenuOpen = {};
      this.playerSpecifierSearchDetail = {};
      this.playerSelectedSpecifierDetail = {};
      await this.fetchOddsGroupDetailLiveV3({
        source: object.event.id,
        group: 0,
        sport: object.sport.id,
        tournament: object.tournament.id,
        marketId: market.marketId
      });
      if (this.getEventsLiveDetail && this.getEventsLiveDetail.length > 0) {
        this.object = this.getEventsLiveDetail[0];
        this.initPanels(this.object.event.odds);
      }
      this.tab_loading = false;
    },

    async exitSearchMode(object) {
      const ctx = this.searchModeContext;
      this.searchModeContext = null;
      this.panelsState = {};
      this.compactModes = {};
      this.selectedSpecifiers = {};
      this.scorePickers = {};
      this.expandedPlayerMarkets = {};
      this.selectedPlayerTeam = {};
      this.playerSpecifierMenuOpen = {};
      this.playerSpecifierSearchDetail = {};
      this.playerSelectedSpecifierDetail = {};
      this.groupSelected = null;
      await this.changeGroup(object.event.id, ctx.groupId, object.sport.id, object.category.id, object.tournament.id);
    }
  },
  watch: {
    filteredGroups(newGroups) {
      if (!newGroups.length) return;
      const stillExists = newGroups.some(g => g._id === this.groupSelected);
      if (!stillExists && (this.groupSelected === 'favourites' || this.groupSelected === 'betbuilder')) {
        const firstGroup = newGroups[0];
        if (this.object) {
          const { event, sport, category, tournament } = this.object;
          this.changeGroup(event.id, firstGroup._id, sport.id, category.id, tournament.id);
        } else {
          this.groupSelected = firstGroup._id;
        }
      }
    },
    searchModeContext(val) {
      this.$nextTick(() => {
        const refs = this.$refs.smartToolbar;
        const tb = Array.isArray(refs) ? refs[0] : refs;
        if (tb) tb.setSearchSelectedMode(!!val);
      });
    },
    searchQuery(val) {
      if (val && !this.availableMarketsLoaded) {
        this._loadAvailableMarkets();
      }
      this.showMarketSearchDropdown = !!val;
    },
    getEventsLiveDetail: {
      handler(val) {
        if (val && val.length > 0) {
          const currentEventId = val[0].event.id;
          const oldEventId = this.object && this.object.event ? this.object.event.id : null;

          this.object = val[0];

          if (currentEventId !== oldEventId) {
            if (this.getMarketsGroupsDetailLive && this.getMarketsGroupsDetailLive.length > 0) {
              this.groupSelected = this.getMarketsGroupsDetailLive[0]._id;
            }

            this.panelsState = {};
            this.compactModes = {};
            this.selectedSpecifiers = {};
            this.openSpecifierDropdowns = {};
            this.expandedPlayerMarkets = {};
            this.selectedPlayerTeam = {};
            this.scorePickers = {};
            this.searchQuery = '';
            this.availableMarketsLoaded = false;
            this.showMarketSearchDropdown = false;
            this.searchModeContext = null;

            this.initPanels(val[0].event.odds);

            setTimeout(() => {
              this.marketsLimit = 1000;
            }, 150);
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this._quickSelectLoadingHandler = (flag) => { this.loading = flag; };
    this.$root.$on('isloading_quick_select_event_live', this._quickSelectLoadingHandler);
    if (this.isMobileOnly) this.colToShow = [0];
    window.addEventListener('resize', this.onResize);
    this.onResize();
    setTimeout(() => {
      const el = Array.isArray(this.$refs.navLeft)
          ? this.$refs.navLeft[0]
          : this.$refs.navLeft;
      if (el) el.scrollLeft = el.scrollWidth;
    }, 200);

    const ms = this.getLivePollingIntervalMs;
    if (ms > 0) {
      this._pollTimer = setInterval(() => {
        if (document.visibilityState !== 'visible') return;
        this.$store.dispatch('detailLive/silentRefreshLiveDetailV2');

      }, ms);
    }
  },
  beforeDestroy() {
    this.$root.$off('toggle-tracker-size', this._trackerSizeHandler);
    this.$root.$off('isloading_quick_select_event_live', this._quickSelectLoadingHandler);
    window.removeEventListener('resize', this.onResize);
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
  }
};
</script>

<style scoped>

.tracker-custom-tooltip {
  position: fixed; background: var(--bg-card); color: #fff;
  padding: 8px 14px; border-radius: 8px; font-size: var(--font-size-2xl); font-weight: 900;
  z-index: 999999; pointer-events: none; box-shadow: 0 4px 15px rgba(0,0,0,0.8);
  white-space: nowrap; transform: translate(0, 0);
}

.match-finished-badge {
  display: inline-block;
  flex-shrink: 0;
  font-size: var(--font-size-md);
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--color-primary, #a37e2c);
  border: 1px solid var(--color-primary, #a37e2c);
  border-radius: 3px;
  padding: 1px 5px;
  margin-left: 8px;
  white-space: nowrap;
}

.markets-wrapper--finished {
  opacity: 0.45;
  pointer-events: none;
  user-select: none;
}

.markets-wrapper.odds-loading { pointer-events: none; opacity: 0.5; }

/* WIDGET E TRACKER STYLES ISOLATI */
.live-tracker-master-wrapper {
  display: block;
  clear: both;
  width: 100%;
  max-width: 1400px;
  margin: 12px auto;
  position: relative;
  z-index: 10;
}

.desktop-tracker-section {
  width: 100%;
  background: var(--bg-panel, #1e1e1e);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.widget-smart-toolbar-wrapper {
  margin-bottom: 8px;
}

.widget-login-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 36px 16px;
  margin: 8px 0;
  border-radius: 12px;
  text-align: center;
  background: rgba(0,0,0,0.2);
}

/* STILI LAYOUT MERCATI */
.market-view-container { font-family: 'Roboto', sans-serif; color: var(--text-platform); width: 100%; overflow-x: clip; border-radius: 4px }
.z-index-max { z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; }
.sticky-nav { position: sticky; top: 0; z-index: 100; display: flex; justify-content: space-between; align-items: center; padding: 4px 0 0; }
.nav-left { width: 100%; display: flex; align-items: center; gap: 8px; padding: 0 !important; color: #fff; font-weight: bold; height: 40px; border: none !important; background: transparent !important; }
.nav-left span { display: inline-flex !important; align-items: center; font-size: var(--font-size-3xl); line-height: 1; }
.nav-left .close-icon-btn { flex-shrink: 0; }
.nav-left .breadcrumbs { flex: 1; min-width: 0; overflow: hidden; }
.breadcrumbs::-webkit-scrollbar { display: none; }
.breadcrumbs { display: flex; align-items: center; font-size: var(--font-size-2xl); white-space: nowrap; gap: 20px; min-width: 0; overflow: hidden; flex-wrap: nowrap; }
.breadcrumbs .crumb { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.crumb { color: var(--text-op-50-platform); font-weight: 500; } .crumb.highlight { color: var(--text-platform); font-weight: 700; }
.close-icon-btn { width: 30px; height: 30px; border: 1px solid var(--hsla-1); border-radius: 15px; background-color: hsla(0, 0%, 100%, 0.07); cursor: pointer; padding: 0; position: relative; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.match-timer .live { color: var(--color-accent) }
.match-timer .info-time-match { color: var(--color-accent); font-weight: bolder }
.match-timer .time-match { font-weight: lighter }
.markets-wrapper { padding: 10px 0; max-width: 1400px; margin: 0 auto; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; }
.favourites-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px 20px; gap: 8px; color: var(--text-op-50-platform, #777); text-align: center; }
.favourites-empty__hint { font-size: var(--font-size-2xl); opacity: 0.7; }
.markets-split-layout { display: flex; gap: 10px; align-items: flex-start; width: 100%; }
.markets-column { flex: 1; min-width: 0; }
.market-panel { background-color: transparent !important; border: none; }
.panel-header { background-color: var(--event-background) !important; min-height: 44px !important; padding: 0 12px !important; border-bottom: 1px solid var(--hsla-1); border-top-left-radius: 4px; border-top-right-radius: 4px; }
.market-name { font-size: var(--font-size-3xl); font-weight: 700; color: var(--text-platform); text-transform: capitalize; }
.header-actions, .market-title-area { display: flex; align-items: center; }
.header-content { display: flex; justify-content: space-between; align-items: center; width: 100%; }
.pin-icon { cursor: pointer; transition: transform 0.2s; } .pin-icon:hover { transform: scale(1.2); color: var(--text-platform) !important; }
.info-market-icon { cursor: pointer; opacity: 0.6; transition: all 0.2s; color: #aaa; } .info-market-icon:hover { opacity: 1; color: var(--v-primary-base); }
.panel-body ::v-deep .v-expansion-panel-content__wrap { padding: 0 !important; }
.grid-container { background-color: var(--event-background); padding: 0; border-top: none; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px; overflow: hidden; }
.market-row { padding: 0; }

/* Main/All pill */
.main-all-pill { display: inline-flex; align-items: center; gap: 4px; background-color: #2a2a2a; border-radius: 20px; padding: 3px; }
.main-all-pill button { background: transparent; border: none; color: var(--text-op-50-platform); font-size: var(--font-size-xl); font-weight: 700; padding: 4px 12px; border-radius: 16px; cursor: pointer; transition: all 0.2s; min-height: 24px; }
.main-all-pill button.active { background-color: #b3b3b3; color: #222222; }

/* Correct Score dedicated body */
.cs-dedicated-body { display: flex; padding: 20px 24px; justify-content: space-between; align-items: center; }
.cs-teams-container { display: flex; gap: 60px; align-items: center; }
.cs-team-col { display: flex; flex-direction: column; align-items: center; gap: 12px; }
.cs-team-label { font-size: var(--font-size-3xl); font-weight: 700; color: var(--text-platform); }
.cs-stepper { display: flex; align-items: center; gap: 12px; }
.cs-step-btn { width: 32px; height: 32px; background-color: transparent; border: 1px solid var(--hsla-1); border-radius: 3px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: border-color 0.2s; }
.cs-step-btn:hover:not(:disabled) { border-color: var(--color-accent); }
.cs-step-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.cs-step-val { font-size: var(--font-size-8xl); font-weight: 700; color: #ffffff; min-width: 24px; text-align: center; }
.cs-odd-col { flex-grow: 1; display: flex; justify-content: flex-end; padding-left: 40px; }
.cs-odd-btn { width: 100%; max-width: 260px; background-color: var(--bg-cell); border: 1px solid #555555; border-radius: 4px; color: #fdd835; font-size: var(--font-size-4xl); padding: 12px 0; cursor: pointer; transition: background-color 0.2s; text-align: center; }
.cs-odd-btn:hover { background-color: #444444; }
.cs-odd-btn.odd_selected { background-color: #00e676; color: #fff; border-color: var(--color-accent); }
.cs-odd-btn.locked { color: #888; cursor: not-allowed; border-color: #444; }
@media (max-width: 600px) {
  .cs-dedicated-body { flex-direction: column; gap: 24px; align-items: stretch; }
  .cs-teams-container { justify-content: space-around; gap: 0; }
  .cs-odd-col { max-width: 100%; width: 100%; padding-left: 0; }
  .cs-odd-btn { max-width: 100%; }
}


/* Player market - team tab toolbar */
.player-team-toolbar { margin-bottom: 8px; background-color: transparent; border-radius: 4px; overflow: hidden; }
.player-team-track { display: flex; position: relative; width: 100%; }
.player-team-btn { flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; background: transparent; border: none; padding: 7px 8px; font-size: var(--font-size-2xl); font-weight: 600; color: var(--text-op-50-platform); cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; transition: color 0.2s; }
.player-team-btn.active { color: var(--text-platform); font-weight: 700; }
.player-team-indicator { position: absolute; bottom: 0; height: 2px; background-color: var(--color-primary); transition: left 0.3s ease, width 0.3s ease; }
.player-specifier-row { width: 100%; margin-bottom: 8px; }
.player-spec-btn { display: flex; align-items: center; background: #1e1e1e; border: 1px solid #444; border-radius: 4px; padding: 5px 8px; cursor: pointer; font-size: var(--font-size-xl); color: #ccc; width: 100%; gap: 4px; transition: border-color 0.2s; }
.player-spec-btn:hover { border-color: var(--color-primary-light); color: #fff; }
.player-spec-inner { background: #1e1e1e; border: 1px solid #444; border-radius: 4px; min-width: 200px; max-width: 300px; }
.player-spec-search-row { display: flex; align-items: center; gap: 6px; padding: 6px 8px; border-bottom: 1px solid #333; }
.player-spec-search-input { flex: 1; background: transparent; border: none; outline: none; color: #fff; font-size: var(--font-size-2xl); }
.player-spec-list { max-height: 240px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #555 #222; }
.player-spec-item { padding: 6px 10px; font-size: var(--font-size-2xl); color: #ccc; cursor: pointer; border-bottom: 1px solid #2a2a2a; }
.player-spec-item:hover { background: #2a2a2a; color: #fff; }
.player-spec-item.active { color: var(--color-primary-light); font-weight: 700; background: rgba(0,96,57,0.10); }
.player-spec-empty { padding: 10px; text-align: center; font-size: var(--font-size-xl); color: #666; }
.player-filtered-container { display: flex; flex-direction: column; gap: 8px; background-color: var(--bg-panel); border-radius: 4px; padding: 6px 8px; }
.player-row-odd { display: flex; align-items: center; justify-content: space-between; height: 32px; }
.show-more-toggle { text-align: center; background: transparent; color: var(--color-accent); font-size: var(--font-size-xl); font-weight: 700; cursor: pointer; padding: 6px; margin-top: 4px; border-radius: 4px; transition: all 0.2s; display: flex; align-items: center; justify-content: center; gap: 2px; }
.show-more-toggle:hover { background: var(--bg-cell-hover); }

@keyframes flash-green { 0% { background-color: var(--bg-odd-up); border-color: var(--bg-odd-up); } 100% { background-color: var(--bg-cell); } }
@keyframes flash-red { 0% { background-color: var(--bg-odd-down); border-color: var(--bg-odd-down); } 100% { background-color: var(--bg-cell); } }
.locked { opacity: 0.4; cursor: not-allowed; justify-content: center; } .invert { filter: invert(1); }

/* Skeleton loader */
.skeleton-loader { padding: 8px; }
.skel-split-layout { display: flex; gap: 8px; }
.skel-column { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.skel-panel { background-color: var(--bg-card); border-radius: 4px; overflow: hidden; }
.skel-panel-header { height: 36px; background-color: var(--bg-header); display: flex; align-items: center; padding: 0 12px; border-bottom: 1px solid var(--border-color); }
.skel-panel-body { padding: 6px; }
.skel-odds-grid { display: grid; gap: 6px; }
.skel-odds-grid.cols-2 { grid-template-columns: repeat(2, 1fr); }
.skel-odds-grid.cols-3 { grid-template-columns: repeat(3, 1fr); }
.skel-item { background-color: var(--skel-box-bg); border-radius: 4px; overflow: hidden; position: relative; }
.skel-item::after { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent); animation: skel-shimmer 1.5s infinite; }
@keyframes skel-shimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }
.skel-label { height: 11px; }
.skel-odd { height: 36px; }
.w-35 { width: 35%; } .w-40 { width: 40%; } .w-45 { width: 45%; } .w-50 { width: 50%; } .w-55 { width: 55%; } .w-60 { width: 60%; }
@media (max-width: 960px) { .skel-split-layout { flex-direction: column; } }

/* SCC specifier table */
.scc-line-row { display: grid; border-top: 1px solid var(--hsla-1); }
.scc-outcomes-header .scc-spec-label,
.scc-outcomes-header .scc-odd-header { font-size: var(--font-size-xl); font-weight: 700; color: var(--text-platform); text-transform: uppercase; padding: 5px 8px; text-align: center; background: var(--bg-header, rgba(0,0,0,0.04)); border-right: 1px solid var(--border-color); }
.scc-outcomes-header .scc-odd-header:last-child { border-right: none; }
.scc-outcomes-header .scc-spec-label { min-height: auto; }
.scc-spec-cell { display: flex; align-items: center; justify-content: center; font-size: var(--font-size-2xl); color: var(--text-op-50-platform); padding: 6px 8px; min-height: 44px; border-right: 1px solid var(--hsla-1); gap: 4px; }
.scc-odd-cell { display: flex; align-items: stretch; min-height: 48px; border-right: 1px solid var(--hsla-1); }
.scc-odd-cell:last-child { border-right: none; }
.scc-value { width: 100%; border: none !important; border-radius: 0 !important; display: flex; align-items: center; justify-content: center; font-size: var(--font-size-3xl); font-weight: 600; min-height: 44px; color: var(--text-bg-cell); }
.scc-value:hover { background: var(--bg-cell-hover) !important; color: var(--text-bg-cell-hover); }

/* Odds grid borders */
.odds-flex-row .odd-cell-wrapper { border-right: 1px solid var(--hsla-1); }
.odds-flex-row[data-cols="2"] .odd-cell-wrapper:nth-child(2n) { border-right: none; }
.odds-flex-row[data-cols="3"] .odd-cell-wrapper:nth-child(3n) { border-right: none; }
.odds-flex-row.multirow .odd-cell-wrapper { border-bottom: 1px solid var(--hsla-1); }

.compact-view-wrapper { padding: 8px 0; }

.odd-cell { border-radius: inherit; padding: 0 12px; height: 48px; }
.odd-cell:hover { border-bottom: 1px solid transparent; }
@media (hover: hover) {
  .odd-cell:hover .cell-content .outcome-label { color: var(--text-op-50-platform); }
  .odd-cell:hover .cell-content .outcome-value { color: var(--text-bg-cell); }
}
.cell-content { flex-direction: row; justify-content: space-between; }
.outcome-value { color: var(--text-bg-cell); }
.outcome-value, .outcome-label { font-size: var(--font-size-3xl); }

.specifier-tag {
  background: var(--color-accent);
  color: #000;
  font-size: var(--font-size-md);
  padding: 1px 6px;
  border-radius: 2px;
  font-weight: 900;
  display: none;
}

.odd-line-val { font-weight: 700; font-size: var(--font-size-xl); margin-left: 4px; }
.empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px 20px; text-align: center; color: #666; }

@media (max-width: 960px) { .markets-split-layout { flex-direction: column; } .markets-column { width: 100%; } .match-hero-live { padding: 20px 10px; } }
@media (max-width: 600px) {
  .markets-wrapper { padding: 5px; }
  .panel-header { padding: 0 8px !important; }
  .odd-cell { height: 44px; background-color: var(--bg-cell); border: 1px solid var(--border-color);  display: flex; justify-content: space-between; align-items: center; padding: 0 10px; cursor: pointer; transition: background-color 0.15s; position: relative; overflow: hidden; touch-action: manipulation; }
  .odd-cell:active { opacity: 0.75; }
  .skel-odd { height: 44px; }
  .player-row-odd { display: flex; align-items: center; justify-content: space-between; min-height: 44px; }
  .player-team-btn { flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; background: transparent; border: none; padding: 10px 8px; font-size: var(--font-size-3xl); font-weight: 600; color: var(--text-op-50-platform); cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; transition: color 0.2s; min-height: 44px; touch-action: manipulation; }
  .show-more-toggle { min-height: 44px; padding: 12px; font-size: var(--font-size-2xl); touch-action: manipulation; display: flex; align-items: center; justify-content: center; }
}

/* ── Info Modal ───────────────────────────────────────────────── */
.mim-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mim-panel {
  background: var(--bg-card-gradient-to-r);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.7);
  border: 1px solid #2e2e2e;
  width: 480px;
  max-width: 90vw;
  animation: mimFadeIn 0.2s ease;
}
.mim-panel--mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  border-radius: 16px 16px 0 0;
  max-height: 80vh;
  overflow-y: auto;
  padding-bottom: 80px;
  animation: mimSlideUp 0.3s cubic-bezier(0.22, 0.68, 0.55, 1.25);
}
@keyframes mimFadeIn {
  from { opacity: 0; transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1); }
}
@keyframes mimSlideUp {
  from { transform: translateY(110%); }
  to   { transform: translateY(0); }
}

/* Header */
.mim-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: var(--bg-card-gradient-to-r);
  border-bottom: 1px solid #2a2a2a;
}
.mim-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mim-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: background 0.15s;
}
.mim-close-btn:hover { background: rgba(255,255,255,0.08); }

/* Body */
.mim-body {
  padding: 16px;
}
.mim-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
}
.mim-market-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 4px;
}
.mim-market-name {
  font-size: var(--font-size-7xl);
  font-weight: 900;
  color: #fff;
  text-transform: capitalize;
  line-height: 1.2;
  flex: 1;
}
.mim-market-id {
  font-size: var(--font-size-md);
  font-family: monospace;
  color: var(--text-op-50-platform);
  background: var(--bg-body);
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  white-space: nowrap;
}

.mim-section-label {
  display: flex;
  align-items: center;
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--text-op-50-platform);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 8px;
}
.mim-desc-section {
  margin-bottom: 4px;
}
.mim-no-desc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  color: #555;
  font-size: var(--font-size-3xl);
}
.mim-desc-text {
  font-size: var(--font-size-3xl);
  line-height: 1.65;
  color: #bbb;
  margin: 0;
}

/* Mobile drag handle */
.mim-drag-handle {
  width: 36px;
  height: 4px;
  background: #3a3a3a;
  border-radius: 2px;
  margin: 10px auto 6px;
}

/* MARKET SEARCH DROPDOWN */
.market-search-dropdown {
  position: relative;
  z-index: 200;
  background: var(--bg-panel, #1e1e1e);
  border: 1px solid var(--border-color, #444);
  border-top: none;
  border-radius: 0 0 6px 6px;
  max-height: 280px;
  overflow-y: auto;
  box-shadow: 0 6px 16px rgba(0,0,0,0.5);
  margin-bottom: 8px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}
.market-search-item {
  padding: 10px 14px;
  font-size: var(--font-size-3xl);
  color: var(--text-platform, #e0e0e0);
  cursor: pointer;
  border-bottom: 1px solid var(--bg-header, #2a2a2a);
  transition: background 0.15s;
}
.market-search-item:last-child { border-bottom: none; }
.market-search-item:hover { background: var(--bg-cell, #2e2e2e); color: #fff; }

</style>

<style scoped>
.v-menu__content.dark-menu {
  background-color: var(--bg-panel) !important;
  border: 1px solid var(--bg-cell);
}

.v-menu__content.dark-menu .v-list {
  background-color: var(--bg-panel) !important;
  padding: 0 !important;
  color: var(--text-platform) !important;
}

.v-menu__content.dark-menu .v-list-item {
  background-color: var(--bg-panel) !important;
  color: var(--text-platform) !important;
  border-bottom: 1px solid var(--bg-header);
}

.v-menu__content.dark-menu .v-list-item .v-list-item__title {
  color: var(--text-platform) !important;
}

.v-menu__content.dark-menu .v-list-item:hover {
  background-color: var(--bg-cell) !important;
}

.match-hero {
  position: relative;
  border-radius: 6px;
}


.quick-select-live-wrapper {
  position: relative;
  z-index: 50;
}

.match-hero > * {
  position: relative;
  z-index: 2;
}

.correct-score-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  width: 100%;
  padding: 8px;
}

.correct-score-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.correct-score-grid .odd-cell-wrapper .odd-cell {
  border: 1px solid var(--border-color, #444);
  border-radius: 4px;
}

.correct-score-grid .odd-cell-wrapper .odd-cell.locked {
  border-color: var(--hsla-1, #333);
}
@media (max-width: 960px) {
  .match-hero { padding: 0 10px!important; }
}

.odd-cell.odd_selected .outcome-label{
  color: var(--text-cell-active)!important;
}

.odd-cell.odd_selected{
  border-color: transparent;
  background: var(--bg-cell-active)!important;
}
.odd-cell.odd_selected .cell-content{
  border-color: transparent;
}
</style>